"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hideIfNotValue = exports.showIfNotValue = exports.hideIfValue = exports.showIfValue = exports.kode4FormCustomConditionHandlerDeactivate = exports.kode4FormCustomConditionHandlerActivate = exports.kode4CustomConditionFieldEqualsNot = exports.kode4CustomConditionFieldEquals = void 0;
exports.kode4CustomConditionFieldEquals = (fieldname, value) => (form, field) => {
    const fld = form.getField(fieldname);
    return Boolean((fld === null || fld === void 0 ? void 0 : fld.value) == value);
};
exports.kode4CustomConditionFieldEqualsNot = (fieldname, value) => (form, field) => {
    const fld = form.getField(fieldname);
    return Boolean((fld === null || fld === void 0 ? void 0 : fld.value) != value);
};
exports.kode4FormCustomConditionHandlerActivate = (options = ['hidden', 'disabled']) => (form, field) => {
    if (options.includes('hidden')) {
        field.hidden = false;
    }
    if (options.includes('disabled')) {
        field.disabled = false;
    }
};
exports.kode4FormCustomConditionHandlerDeactivate = (options = ['hidden', 'disabled']) => (form, field) => {
    if (options.includes('hidden')) {
        field.hidden = true;
    }
    if (options.includes('disabled')) {
        field.disabled = true;
    }
};
exports.showIfValue = (fieldname, value) => {
    return {
        conditions: exports.kode4CustomConditionFieldEquals(fieldname, value),
        handleThen: exports.kode4FormCustomConditionHandlerActivate(),
        handleElse: exports.kode4FormCustomConditionHandlerDeactivate(),
    };
};
exports.hideIfValue = (fieldname, value) => {
    return {
        conditions: exports.kode4CustomConditionFieldEquals(fieldname, value),
        handleThen: exports.kode4FormCustomConditionHandlerDeactivate(),
        handleElse: exports.kode4FormCustomConditionHandlerActivate(),
    };
};
exports.showIfNotValue = (fieldname, value) => {
    return {
        conditions: exports.kode4CustomConditionFieldEqualsNot(fieldname, value),
        handleThen: exports.kode4FormCustomConditionHandlerActivate(),
        handleElse: exports.kode4FormCustomConditionHandlerDeactivate(),
    };
};
exports.hideIfNotValue = (fieldname, value) => {
    return {
        conditions: exports.kode4CustomConditionFieldEqualsNot(fieldname, value),
        handleThen: exports.kode4FormCustomConditionHandlerDeactivate(),
        handleElse: exports.kode4FormCustomConditionHandlerActivate(),
    };
};
